// import FooterInfo from "@/components/layout/FooterInfo";
// import MobileProfileModal from "@/components/mobile/MobileProfileModal";
import FooterNoticeSwiper from './footer/FooterNoticeSwiper';
// import useIsMobile from "@/src/hooks/useIsMobile";
// import useLogin from "@/src/hooks/useLogin";
// import { useRouter } from "next/router";
import { isMobile } from 'react-device-detect';
import React, { useState } from 'react';
import '../css/footer.css';
// import { useIsMobile } from '../hooks/useIsMobile';

const ShopFooter = () => {
  //   const router = useRouter();
  //   const isLogin = useLogin();

  //  const [isMobileProfileOpen, setIsMobileProfileOpen] = useState(false);
  //  const isMobile = useIsMobile();

  //   const openMobileProfile = async () => {
  //     if (!isLogin) {
  //       router.push(`${loginUrl}${encodeURI(router.asPath)}`);
  //       return;
  //     }

  //     setIsMobileProfileOpen(true);
  //   };

  //   const closeMobileProfile = () => {
  //     setIsMobileProfileOpen(false);
  //   };
  const _top = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <footer id="footer">
        <div className="bottom-button-container">
          <button className="top-button" onClick={_top}></button>
        </div>
        <div className="foot_sec01">
          <FooterNoticeSwiper id={'footer-notice'} />
        </div>
        <div className="foot_sec02">
          <div className="foot_logo">
            <span className="blind">ANIPLUS</span>
          </div>
          <div className="foot_menu">
            <ul className="foot_menu_col2">
              <li className="hide">
                <a
                  onClick={(e) => {
                    window.open('https://www.aniplustv.com/ticket');
                  }}
                >
                  멤버십
                </a>
              </li>

              <li className={isMobile ? 'hide' : null}>
                <a
                  onClick={(e) => {
                    window.open('https://www.aniplustv.com/customer/1');
                  }}
                >
                  고객센터
                </a>
              </li>

              <li className="hide">
                <a
                  onClick={(e) => {
                    window.open('https://www.aniplustv.com/event');
                  }}
                >
                  이벤트
                </a>
              </li>
            </ul>
            <ul className="foot_menu_col1">
              <li>
                <a href="https://company.aniplustv.com/" target={'_blank'}>
                  회사소개
                </a>
              </li>
              <li>
                <a
                  href="https://company.aniplustv.com/contact"
                  target={'_blank'}
                >
                  광고/제휴문의
                </a>
              </li>
              <li>
                <a
                  href="https://www.aniplustv.com/customer/4"
                  target={'_blank'}
                >
                  이용약관
                </a>
              </li>
            </ul>
          </div>
          <div className="foot_cust">
            <div className="tel">T. 070-7162-7013</div>
            <div className="cus">
              10:00 ~ 18:00 주말/공휴일 휴무
              <br />
              점심시간 : 12:30~ 13:30
            </div>
          </div>
          <ul className="foot_sns">
            <li>
              <a
                href="https://www.instagram.com/aniplusasia/"
                target={'_blank'}
              >
                Instagram
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/@ANIPLUSINC" target={'_blank'}>
                youtube
              </a>
            </li>
            <li>
              <a href="https://twitter.com/ANIPLUS_SHOP" target={'_blank'}>
                X
              </a>
            </li>
            <li>
              <a href="https://blog.naver.com/aniplus_shop" target={'_blank'}>
                Naver Blog
              </a>
            </li>
          </ul>
          <div className="foot_info_box">
            <p className="foot_info">
              상호 : 주식회사 애니플러스 ㅣ 대표이사 : 전승택 ㅣ
              개인정보관리책임자 : 손혜환
              <br />
              주소 : 서울 영등포구 국제금융로 10 Three IFC 28층
              <br />
              사업자등록번호 : 318-81-09181 ㅣ 통신판매업신고번호 : 제
              2020-서울영등포-2089 호 ㅣ webmaster@aniplustv.com
            </p>

            <p className="foot_copy">
              Copyright (c) 2023 ANIPLUS INC. All rights reserved
            </p>
          </div>
        </div>
      </footer>
      {/* {isMobile && (
        <>
          <MobileProfileModal
            isOpen={isMobileProfileOpen}
            closeModal={closeMobileProfile}
          />
          <div className="m_footer_menu">
            <ul>
              <li
                onClick={(e) => {
                  router.push("https://www.aniplustv.com");
                }}
              >
                <a>작품감상</a>
              </li>
              <li
                onClick={(e) => {
                  router.push({ pathname: "/" });
                }}
              >
                <a>쇼핑</a>
              </li>
              <li
                onClick={(e) => {
                  router.push("https://www.aniplustv.com/store");
                }}
              >
                <a>스토어</a>
              </li>
              <li
                onClick={(e) => {
                  // openMobileProfile();
                }}
              >
                <a>더보기</a>
              </li>
            </ul>
          </div>
        </>
      )} */}
    </>
  );
};

export default ShopFooter;
